export const CHANNEL_EDITOR_KEYS = Object.freeze({
  THUMBNAIL_SIZE: {
    WIDTH: 192,
    HEIGHT: 108,
  },
});

export const NULL_MEDIA = Object.freeze({
  uri: null,
  type: 'wb/placeholder',
  thumbnail_pattern: '',
  title: '',
});

export const INVALID_DURATION = -1;
export const MIN_DURATION = 5;
export const MAX_DURATION = 180;
